import { FC, MouseEvent } from 'react'
import { Play, Pause, RotateCcw } from 'lucide-react'
import { cva, VariantProps } from 'class-variance-authority'

type CmpProps = VariantProps<typeof togglerVariants> & {
  isPlaying: boolean
  togglePlay: (e: MouseEvent<HTMLDivElement>) => void
  isEnded?: boolean
  canShowRestart?: boolean
}

const togglerVariants = cva('cursor-pointer text-white color-white', {
  variants: {
    position: {
      center:
        'bg-alpha-black-50 absolute left-[50%] top-[50%] flex size-12 translate-x-[-50%] translate-y-[-50%] items-center justify-center rounded-[50%] stroke-white',
      'bottom-left': 'size-xxs [&_svg]:size-xxs',
    },
  },
})

const PlayToggler: FC<CmpProps> = ({
  isEnded,
  position,
  isPlaying,
  togglePlay,
  canShowRestart = true,
}) => {
  const canShowRestartBtn = isEnded && canShowRestart

  return (
    <div onClick={togglePlay} className={togglerVariants({ position })}>
      {canShowRestartBtn ? (
        <RotateCcw data-testid="rewind" />
      ) : isPlaying ? (
        <Pause data-testid="pause" />
      ) : (
        <Play data-testid="play" />
      )}
    </div>
  )
}

export default PlayToggler
